import React, { useEffect, useState } from "react";
import api from "../../axiosConfig";
import { Table, Container, Row, Col, Form, Alert } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import "../pagination.css";
import { format } from "date-fns";

const IstoricList = () => {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const itemsPerPage = 20;

  useEffect(() => {
    let active = true;
    const fetchItems = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await api.get("/istoric/", {
          params: {
            offset: currentPage * itemsPerPage,
            limit: itemsPerPage,
            search: search,
          },
        });
        if (!active) return;
        setItems(res.data.items || []);
        setTotalCount(res.data.total || 0);
      } catch (error) {
        if (!active) return;
        setItems([]);
        setTotalCount(0);
        setError("Istoricul nu a putut fi încărcat. Reîncarcă pagina pentru a încerca din nou.");
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchItems();
    return () => { active = false; };
  }, [currentPage, search]);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const getActionBadge = (actionType) => {
    if (actionType === "Adăugare") return <span className="badge bg-success">Adăugare</span>;
    if (actionType === "Editare") return <span className="badge bg-warning text-dark">Editare</span>;
    if (actionType === "Ștergere") return <span className="badge bg-danger">Ștergere</span>;
    return <span className="badge bg-secondary">{actionType}</span>;
  };

  const getDocType = (rectype) => {
    if (rectype === 0) return "Intrare furnizor";
    if (rectype === 120) return "Încasare Casă/Bancă";
    if (rectype === 121) return "Plată Casă/Bancă";
    if (rectype === 20) return "Dare în folosință Ob.Inv.";
    if (rectype === 21) return "Transfer Ob.Inv.";
    if (rectype === 22) return "Casare Ob.Inv.";
    const names = {
      1: "NIR", 2: "Proces-verbal", 3: "Bon de consum", 4: "Bon de transfer",
      5: "Factură / aviz client", 6: "Bon de producție",
      110: "Comandă client Service Auto", 111: "Deviz Service Auto",
      119: "Rețetă", 118: "Anexă deviz Service Auto", 117: "Fișă mijloc fix", 300: "Declarație D300", 394: "Declarație D394", 406: "Declarație D406",
      112: "Inventar", 113: "Intervenție contor", 114: "Deviz șantier",
      115: "Raport zilnic șantier", 116: "Situație de lucrări",
      210: "Comandă client SIMAUS", 211: "Comandă producție SIMAUS",
      212: "Fișă-limită SIMAUS", 130: "Notă contabilă manuală",
    };
    return names[rectype] || (rectype >= 1000 ? `Notă contabilă (tip ${rectype - 1000})` : `Tip ${rectype}`);
  };

  return (
    <Container className="mt-4">
      <Row className="mb-3">
        <Col md={8}>
          <h2>Istoric Documente (Audit Log)</h2>
        </Col>
        <Col md={4}>
          <Form.Control
            type="text"
            placeholder="Caută după nr. document..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(0);
            }}
          />
        </Col>
      </Row>

      {error && <Alert variant="danger">{error}</Alert>}
      <Table striped bordered hover size="sm">
        <thead className="table-dark">
          <tr>
            <th>Data & Ora</th>
            <th>Utilizator</th>
            <th>Acțiune</th>
            <th>Modul (Tip Doc)</th>
            <th>Nr. Document</th>
          </tr>
        </thead>
        <tbody>
          {!loading && !error && items.map((item) => (
            <tr key={item.id}>
              <td>{format(new Date(item.action_date), "dd.MM.yyyy HH:mm:ss")}</td>
              <td className="fw-bold">{item.user_nume}</td>
              <td>{getActionBadge(item.action_type_nume)}</td>
              <td>{getDocType(item.bxrectype)}</td>
              <td>{item.bxdoc_no || "-"}</td>
            </tr>
          ))}
          {loading && <tr><td colSpan="5" className="text-center">Se încarcă istoricul...</td></tr>}
          {!loading && !error && items.length === 0 && (
            <tr>
              <td colSpan="5" className="text-center">Nu există înregistrări în istoric.</td>
            </tr>
          )}
        </tbody>
      </Table>
      {!loading && !error && totalCount > itemsPerPage && (
        <ReactPaginate
          previousLabel={"Înapoi"}
          nextLabel={"Înainte"}
          breakLabel={"..."}
          pageCount={Math.ceil(totalCount / itemsPerPage)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination justify-content-center"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          activeClassName={"active"}
          forcePage={currentPage}
        />
      )}
    </Container>
  );
};

export default IstoricList;
